import React from "react";

import { IoMdBookmarks } from "@react-icons/all-files/io/IoMdBookmarks";
import { RiTimerFill } from "@react-icons/all-files/ri/RiTimerFill";

import Loadingnovel from "../../../components/Loadingnovel";

function NovelSkeleton() {
  return (
    <div>
      <div>
        <div title="EyeNovel" className="z-10 relative">
          <div className="group cursor-pointer p-0 sm:p-[6px] relative novel-hover max-h-auto w-full bg-primary">
            <div className="image-effect">
              <div className="flex justify-center items-center opacity-20 bg-secondary rectangle duration-[0] ease-in-out object-cover">
                <Loadingnovel />
              </div>
              <div className="absolute text-tertiary sm:group-hover:top-0 top-0 sm:-top-10 duration-500 ease-in-out flex justify-center items-center w-fit px-4 h-[32px] bg-primary space-x-[4px] font-SoraR">
                <IoMdBookmarks />
                <span className="text-[14px] sm:text[16px]">000</span>
              </div>
              <div className="absolute text-primary -bottom-10 sm:group-hover:bottom-0 sm:-bottom-10 group-hover:bottom-0 duration-500 ease-in-out right-0 flex justify-center items-center w-fit px-4 h-[32px] bg-tertiary space-x-[8px] uppercase font-SoraR">
                <RiTimerFill className="flex-none" />
                <span className=" text-primary font-SoraR text-[10px] sm:text-[13px] line-clamp-1 break-all w-full">
                  wait a sec
                </span>
              </div>
            </div>
            <div className="mt-0 sm:mt-[12px] p-4 sm:p-0 mb-0 sm:mb-[8px] space-y-0 sm:space-y-[6px]">
              <div className="line-clamp-1">
                <h2 className="text-tertiary   text-center sm:text-left capitalize text-[14px] sm:pb-0 pb-0 sm:text-[16px] font-SoraR">
                  EyeNovel
                </h2>
              </div>
              <div className="w-full   h-[0.5px] hidden sm:block bg-tertiary/20"></div>
              <div className="line-clamp-2">
                <p className="text-tertiary  hidden sm:block capitalize  text-[13px] font-SoraL   ">
                  EyeNovel | Read Free Online Novels In Your Favor
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NovelSkeleton;
